import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularBossPdfComponent } from './angular-boss-pdf.component';



@NgModule({
  declarations: [AngularBossPdfComponent],
  imports: [
    CommonModule
  ],
  exports: [AngularBossPdfComponent]
})
export class AngularBossPdfModule { }
